const NOTIFICATION_DOORBELL = "/audios/door_bell.wav";

const Audios = {
  NOTIFICATION_DOORBELL,
};
export default Audios;
